import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { ADD_MATRIX, GET_MATRIX } from '../actions/matrix';
var INITIAL_STATE = {
  matrix: null,
  matrixList: []
};
export default function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case ADD_MATRIX:
      var matrixList = state.matrixList;
      var object = state.matrixList.find(function (t) {
        return t.id == action.payload.id;
      });

      if (object == null) {
        matrixList.push(action.payload);
      } else {
        matrixList.forEach(function (item, i) {
          if (item.id == action.payload.id) a[i] = action.payload;
        });
      }

      return _objectSpread(_objectSpread({}, state), {}, {
        matrixList: matrixList
      });

    case GET_MATRIX:
      return _objectSpread(_objectSpread({}, state), {}, {
        matrix: action.payload
      });

    default:
      return state;
  }
}